import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";


const initialState = {
  value: [],
  loading: false,
};

export const addRoutineRedraws = createAsyncThunk(
  "routineRedraws/addRoutineRedraws",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addRoutineRedrawsSlice = createSlice({
  name: "addRoutineRedraws",
  initialState,
  reducers: {
    clearAddRoutineRedrawResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addRoutineRedraws.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRoutineRedraws.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(addRoutineRedraws.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addRoutineRedrawsList = (state) => state.addRoutineRedraws.value;
export const { clearAddRoutineRedrawResponse } = addRoutineRedrawsSlice.actions;
export default addRoutineRedrawsSlice.reducer;
